import { useLiabilityFieldBindings } from "@Client/@Composables/application-standalone/pages/liabilities/useLiabilityFieldBindings";
import { useLiabilityFieldVisibility } from "@Client/@Composables/application-standalone/pages/liabilities/useLiabilityFieldVisibility";
export const liabilitiesPageBindingsAndVisibilities = (applicantIndex, liabilityIndex, applicantId) => {
  const {
    liabilityType,
    liabilityOwner,
    liabilityLimit,
    liabilityBalance,
    liabilityPayment,
    liabilityMaturityDate,
    liabilityPayoff,
    liabilityDescription
  } = useLiabilityFieldBindings({
    applicantIndex,
    liabilityIndex
  });
  const {
    liabilityTypeVisible,
    liabilityLimitVisible,
    liabilityBalanceVisible,
    liabilityPaymentVisible,
    liabilityMaturityDateVisible,
    liabilityPayoffVisible,
    liabilityDescriptionVisible
  } = useLiabilityFieldVisibility({
    applicantIndex,
    liabilityIndex,
    applicantId
  });
  return {
    bindings: {
      liabilityType,
      liabilityOwner,
      liabilityLimit,
      liabilityBalance,
      liabilityPayment,
      liabilityMaturityDate,
      liabilityPayoff,
      liabilityDescription
    },
    visibilities: {
      liabilityTypeVisible,
      liabilityLimitVisible,
      liabilityBalanceVisible,
      liabilityPaymentVisible,
      liabilityMaturityDateVisible,
      liabilityPayoffVisible,
      liabilityDescriptionVisible
    }
  };
};